// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Check from '../../../../hola/pub/img/hola2023/icons/16/check.svg';
import Approved from '../../../../toolip/pub/img/icons/24/approved.svg';
import Globe from '../../../../toolip/pub/img/icons/24/world.svg';
import Anonymity from '../../../../toolip/pub/img/icons/24/anonymity.svg';
import Save from '../../../../toolip/pub/img/icons/24/resource.svg';
import Users from '../../../../toolip/pub/img/icons/24/users.svg';
import Flexible_usage from
	'../../../../toolip/pub/img/icons/24/flexible_usage.svg';
import Bandwidth from '../../../../toolip/pub/img/icons/24/bandwidth.svg';
import Protect from '../../../../toolip/pub/img/icons/24/protect.svg';
import Seamless from '../../../../toolip/pub/img/icons/24/seamless.svg';
import styles from './why_proxy.module.less';
import cn from 'classnames';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {Editor} from '../../../../shared/editor/editor';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

const default_cards = [
    {
        icon: <Approved/>,
        title: 'High Success Rate',
        description: 'Scraping residential proxies offer a high success rate '+
            'in bypassing detection systems, ensuring efficient data '+
            'extraction.'
    },
    {
        icon: <Globe/>,
        title: 'Geolocation Flexibility',
        description: 'These proxies provide access to a wide range of real '+
            'locations, making it easy to collect data from specific '+
            'geographic areas.'
    },
    {
        icon: <Anonymity/>,
        title: 'Enhanced Anonymity',
        description: 'With real residential IP addresses, scraping '+
            'residential proxies offer superior anonymity, increasing '+
            'smooth access.'
    }
];

interface i_why_proxy_v2_props {
    card1_title?: string;
    card1_description?: string;
    card2_title?: string;
    card2_description?: string;
    card3_title?: string;
    card3_description?: string;
}
export const Why_proxy_v2 = (props: i_why_proxy_v2_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v({no_defaults: true});
    const cards = [
      {
        icon: <Approved/>,
        title: props?.card1_title || default_cards[0].title,
        description: props?.card1_description || default_cards[0].description
      },
      {
        icon: <Globe/>,
        title: props?.card2_title || default_cards[1].title,
        description: props?.card2_description || default_cards[1].description
      },
      {
        icon: <Anonymity/>,
        title: props?.card3_title || default_cards[2].title,
        description: props?.card3_description || default_cards[2].description
      }
    ];
    return <div className={cn(styles.why_block_v2, theme.container)}>
      <div className={styles.flex_why}>
        {cards.map((card, index)=>
          <div key={index} className={styles.one_why_v2}>
            <div className={styles.icon_wrapper}>
              {card.icon}
            </div>
            <p className={cn(theme.p18, theme.med, theme.color_n800)}>
              {t(card.title)}
            </p>
            <p className={cn(theme.p16, theme.reg, theme.color_n700)}>
              {t(card.description)}
            </p>
          </div>
        )}
      </div>
    </div>;
};

interface i_why_proxy_v2_editor_value {
    card1_title?: string;
    card1_description?: string;
    card2_title?: string;
    card2_description?: string;
    card3_title?: string;
    card3_description?: string;
}

interface i_why_proxy_v2_editor_props {
    value?: i_why_proxy_v2_editor_value;
    on_change: (value: i_why_proxy_v2_editor_value)=>void;
}

export const Why_proxy_v2_editor = (props: i_why_proxy_v2_editor_props)=>{
    const {value = {}, on_change} = props;
    type card_key = keyof i_why_proxy_v2_editor_value;
    type editor_type = 'text' | 'textarea';
    const editors = [
        ['card1_title', 'First Card Title', 'text'],
        ['card1_description', 'First Card Description', 'textarea'],
        ['card2_title', 'Second Card Title', 'text'],
        ['card2_description', 'Second Card Description', 'textarea'],
        ['card3_title', 'Third Card Title', 'text'],
        ['card3_description', 'Third Card Description', 'textarea']
    ].map(([key, label, type])=>({
        key: key as card_key,
        label,
        type: type as editor_type
    }));
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Why Proxy Card Content"
    />;
};


interface i_why_proxy_props {
    bg_color?: 'natural' | 'blue' | 'brown' | 'green' | 'purple';
    title: string | JSX.Element;
    title_tag:string;
    product?: 'isp' | 'isp_plus' | 'shared_dc' | 'dedicated_dc' | 'smart_resi';
}

interface i_why_proxy_editor_props {
  value?: i_why_proxy_props;
  on_change: (value: i_why_proxy_props)=>void;
  on_cancel: ()=>void;
}

export const Why_proxy_editor = (props:i_why_proxy_editor_props)=>{
    const [state, set_state] = useState<i_why_proxy_props>(props.value);
    return <Editor
      value={state}
      editors={[
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'title_tag', label: 'Title Ta', type: 'select_tag_selector'},
        {key: 'product',
          label: 'Product: isp, isp_plus, shared_dc, dedicated_dc, smart_resi',
          type: 'text'},
        {key: 'bg_color',
          label: 'bg_color: natural, blue, browsn, green, purple',
          type: 'text'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};

export const Why_proxy = (props: i_why_proxy_props)=>{
    const {bg_color = 'blue', product} = props;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({no_defaults: true});
    const ui_for_user = false;
    const one_why_cls = cn(styles.one_why, ui_for_user ?
      styles[`one_why_${bg_color}`] : styles[`one_why_${bg_color}_v2`]);
    return <div className={cn(styles.why_block, theme.container)}>
      <Dynamic_heading tag={props.title_tag || 'h2'}
        className={styles.title_header}><T>{props.title}</T></Dynamic_heading>
      <p className={theme.u1}><T>Wake up and smell the Proxy!</T></p>
      <div className={styles.flex_why}>
        {product == 'smart_resi' && <Fragment>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>High Success Rate</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Approved /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>High Success Rate</T></p>}
            <p className={cn(!ui_for_user && (theme.p16,
              theme.reg, theme.color_n700))}><T>Scraping residential
              proxies offer a high success rate
              in bypassing detection systems, ensuring efficient data
              extraction</T>.
            </p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}>
                <T>Geolocation Flexibility</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Globe /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}>
              <T>Geolocation Flexibility</T></p>}
            <p className={cn(!ui_for_user && (theme.p16,
              theme.reg, theme.color_n700))}><T>These proxies provide
              access to a wide range of real
              locations, making it easy to collect data from specific
              geographic areas</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Enhanced Anonymity</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Anonymity /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Enhanced Anonymity</T></p>}
            <p className={cn(!ui_for_user && (theme.p16,
              theme.reg, theme.color_n700))}><T>With real residential IP
              addresses, scraping residential
              proxies offer superior anonymity, increasing smooth
              access</T>.</p>
          </div>
        </Fragment>}
        {product == 'shared_dc' && <Fragment>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Cost-Effective</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Save /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Cost-Effective</T></p>}
            <p><T>Shared datacenter proxies
              are more affordable than dedicated
              ones, making them a pocket-friendly option</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Resource Sharing</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Users /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Resource Sharing</T></p>}
            <p><T>Multiple users share the same IP address, distribute the
              load and potentially improve performance
              during off-peak times</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Flexible Usage</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Flexible_usage /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Flexible Usage</T></p>}
            <p><T>Ideal for less intensive tasks, shared datacenter
              proxies are perfect for data collection, and accessing
              geo-restricted content</T>.</p>
          </div>
        </Fragment>}
        {product == 'dedicated_dc' && <Fragment>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>High Performance</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Bandwidth /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>High Performance</T></p>}
            <p><T>Dedicated datacenter proxies offer high-speed and
              reliable connections, ensuring smooth and
              uninterrupted data transfer</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Enhanced Security</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Protect /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Enhanced Security</T></p>}
            <p><T>These proxies provide a high level of anonymity and
              protection from cyber threats, making them ideal for
              sensitive online activities</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Scalability</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Seamless /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Scalability</T></p>}
            <p><T>Easily scalable to meet growing demands, dedicated
              datacenter proxies  handle large volumes of requests
              seamlessly</T>.</p>
          </div>
        </Fragment>}
        {(product == 'isp' || product == 'isp_plus') && <Fragment>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Enhanced Privacy</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Anonymity /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Enhanced Privacy</T></p>}
            <p><T>Protect your online identity and activities with
              top notch anonymity</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Smooth Access</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Flexible_usage /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Smooth Access</T></p>}
            <p><T>Bypass geo-restrictions and get truly global data
              effortlessly</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Reliable Performance</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Bandwidth /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}>
              <T>Reliable Performance</T></p>}
            <p><T>Enjoy stable and high-speed
              connections for seamless online tasks</T>.</p>
          </div>
        </Fragment>}
        {!product && <Fragment>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Reliable Performance</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Flexible_usage /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}>
              <T>Reliable Performance</T></p>}
            <p><T>Enjoy stable and high-speed connections for seamless
              online tasks</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Smooth Access</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Flexible_usage /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Smooth Access</T></p>}
            <p><T>Bypass geo-restrictions and get truly global data
              effortlessly</T>.</p>
          </div>
          <div className={one_why_cls}>
            <div className={styles.title}>
              {ui_for_user ? <Fragment>
                <Check />
                <h3 className={theme.H5}><T>Enhanced Privacy</T></h3>
              </Fragment>
                : <div className={cn(styles.one_why_icon,
                  styles[`one_why_icon_${bg_color}`])}>
                  <Flexible_usage /></div>}
            </div>
            {!ui_for_user && <p className={cn(theme.p18, theme.med,
              theme.color_n800, styles.mb_s)}><T>Enhanced Privacy</T></p>}
            <p><T>Protect your online identity and activities with top
              notch anonymity</T>.</p>
          </div>
        </Fragment>}
      </div>
    </div>;
};
